import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Body, SubmitButton, Field, FormCadastro, GroupField, Input, Form, View, Icon, PageHeader, DatePicker } from '@components';
import { getHeader, putHeader, postHeader, reset } from '@ducks/conectoresHeaders';
import App from '@app';
import styled from 'styled-components';
import { dateToAnsi, DATE_FORMATS } from '@utils';

const StyledGroupField = styled(GroupField)`
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
`;

const ViewValues = styled(View)`
  padding: 20px;
  border: 1px solid #ddd;
  margin-bottom: 20px;
  width: 100%;
  margin-right: 15px;
`;

const IconDelete = styled(Icon.DeleteOutlined)`
  display: flex;
  align-items: center;
  font-size: 20px;
`;

const IconDeleteDesativado = styled(Icon.DeleteOutlined)`
  display: flex;
  align-items: center;
  font-size: 20px;
  opacity: 0.5;
  cursor: not-allowed;
`;

const AdicionarFeedback = styled(View)`
  width: fit-content;
  padding: 10px 10px 10px 0;
`;

const StyledField = styled(Field)`
  margin-bottom: 0;
`;

const ViewDelete = styled(View)`
  height: fit-content;
`;

const DatePickerStyled = styled(DatePicker)`
  width: 100%;
`;

const requiredKeys = [{ key: 'Content-Type', value: 'application/json' }, { key: 'IDENTIFY' }, { key: 'KEY' }, { key: 'TOKEN' }];

export default function CadastroHeader() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const { id, idConfiguracao } = useParams();
  const edicao = id !== '-1';

  const header = useSelector(({ conectoresHeaders }) => conectoresHeaders.get('header'));
  const successHeader = useSelector(({ conectoresHeaders }) => conectoresHeaders.get('successHeader'));

  const successPostHeader = useSelector(({ conectoresHeaders }) => conectoresHeaders.get('successPostHeader'));
  const successPutHeader = useSelector(({ conectoresHeaders }) => conectoresHeaders.get('successPutHeader'));

  const handleReset = () => {
    return dispatch(reset());
  };

  useEffect(() => {
    if (successPostHeader || successPutHeader) {
      handleReset();
      history.goBack();
    }
  }, [successPostHeader, successPutHeader]);

  useEffect(() => {
    if (edicao) {
      dispatch(getHeader(idConfiguracao, id));
    } else {
      form.setFieldsValue({ headerValues: requiredKeys });
    }
  }, []);

  useEffect(() => {
    if (header && edicao) {
      form.setFieldsValue(header);
    }
  }, [successHeader]);

  const handleSubmit = (data) => {
    data.idConfiguracao = idConfiguracao;

    data.dtBase = dateToAnsi(data.dtBase, DATE_FORMATS.ANSI_DATE, DATE_FORMATS.ANSI_DATE);

    if (edicao) {
      data.id = id;
      dispatch(putHeader(data));
    } else {
      dispatch(postHeader(data));
    }
  };

  return (
    <App>
      <Body>
        <PageHeader title='Header' onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <Field label='Descrição' name='nmHeader' rules={[{ required: true, message: 'Informe a descrição' }]}>
                <Input autoFocus />
              </Field>
              <Field
                label='Data inicial de sincronização'
                name='dtBase'
                rules={[{ required: true, message: 'Informe a data inicial de sincronização' }]}
              >
                <DatePickerStyled format='DD/MM/YYYY' />
              </Field>
            </GroupField>
            <GroupField>
              <ViewValues>
                <View>
                  <strong>Header - Values</strong>
                </View>
                <Form.List name='headerValues'>
                  {(fields, { add, remove }) => {
                    let index = 0;

                    return (
                      <>
                        {fields.map((field) => {
                          index += 1;
                          return (
                            <StyledGroupField key={`fb-${index}`}>
                              <Field label='Key' name={[field.name, 'key']} rules={[{ required: true, message: 'Informe a key' }]}>
                                <Input autoFocus disabled={index < 5} />
                              </Field>

                              <Field label='Value' name={[field.name, 'value']} rules={[{ required: true, message: 'Informe o value' }]}>
                                <Input disabled={index < 2} />
                              </Field>

                              <View justifyContent='center'>
                                <ViewDelete>
                                  {index > 4 ? (
                                    <IconDelete onClick={() => remove(field.name)} className={'action-element' /*eslint-disable-line*/} />
                                  ) : (
                                    <IconDeleteDesativado />
                                  )}
                                </ViewDelete>
                              </View>
                            </StyledGroupField>
                          );
                        })}
                        <StyledField>
                          {/*eslint-disable-next-line*/}
                          <AdicionarFeedback onClick={() => add()} horizontal alignItems='center' className='action-element'>
                            <Icon.PlusOutlined />
                            &nbsp;Header - Value
                          </AdicionarFeedback>
                        </StyledField>
                      </>
                    );
                  }}
                </Form.List>
              </ViewValues>
            </GroupField>
            <SubmitButton type='success' htmlType='submit' block>
              Salvar
            </SubmitButton>
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
